import buildLinkElement from './build-link-element';

export default {
  buildLinkElement,
};
